import { render, staticRenderFns } from "./mosquito_species.vue?vue&type=template&id=672a8d23&"
import script from "./mosquito_species.vue?vue&type=script&lang=js&"
export * from "./mosquito_species.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports